module.exports = __webpack_public_path__ + "img/opportunities-3.jpg";